import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font } from '../theme/base/mixins';
import { StyledDivComponent, StyledSpanComponent } from '../types';
import { FontIconProps, FontIconSpan } from './FontIcon';
import { Anker } from './Link';
import { Paragraph } from './Paragraph';
import { Section } from './Section';

interface DataLayerMobileProps {
  show?: boolean;
}

type DataLayerMobilePropsThemed = ThemeProps<Theme> & DataLayerMobileProps;

export const DataLayerMobile: StyledDivComponent<
  DataLayerMobileProps
> = styled.div`
  display: none;

  ${Section} {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  ${(props: DataLayerMobilePropsThemed) =>
    props.show &&
    css`
      display: block;
      background: ${props.theme.colors.dataLayer};
      color: ${props.theme.colors.white};
      position: fixed;
      z-index: 200;
    `}
`;

export const DataLayerMobileContent: StyledDivComponent = styled.div`
  ${font()};

  ${Paragraph} {
    ${font(1.8, 2.4, '300')};
  }

  ${Anker} {
    color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
    font-weight: 300;
  }
`;

export const DataLayerHeader: StyledDivComponent = styled.div`
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
  font-weight: 500;
  font-size: 3.2rem;
  line-height: 1;
  margin-bottom: 15px;
`;

type DataLayerLinkProps = FontIconProps & {
  active?: boolean;
};

type DataLayerLinkPropsThemed = ThemeProps<Theme> & DataLayerLinkProps;

export const DataLayerLink: StyledSpanComponent<
  DataLayerLinkProps
> = FontIconSpan.extend`
  display: block;
  right: 65px;
  position: absolute;
  height: 100%;
  padding: 0 15px;
  color: ${(props: DataLayerLinkPropsThemed) => props.theme.colors.grayMedium};
  cursor: pointer;

  &:before {
    margin: 0;
    font-size: 3rem;
    line-height: 6rem;
  }

  ${(props: DataLayerLinkPropsThemed) =>
    !props.active &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        width: 1px;
        height: 36px;
        background: ${props.theme.colors.grayLight};
        transform: translateY(-50%);
        right: 0;
      }
    `}

  ${(props: DataLayerLinkPropsThemed) =>
    props.active &&
    css`
      background: ${props.theme.colors.dataLayer};
      color: ${props.theme.colors.white};
    `}
`;
